export const pageName = {
  jcal: "Installationsbeispiele",
  alxq: "Fall-Details",
  ppdt: "Markendynamik",
  rz: "Authentifizierung",
  azzd: "Installationsanleitung",
  by: "Wartung ",
  cjwt: "Häufig gestellte Fragen",
  bz: "Hilfe ",
  cpzx: "Produktzentrum",
  gsm: "Wrapping Film",
  zbcx: "Garantie-Anfrage",
  jxscx: "Händler finden",
  bjcx: "Preisanfrage",
  jjfa: "Lösung",
  das: "DAS ",
  zyazry: "Händler werden",
  azpx: "Installationstraining"
};
export default {
  // 首页
  About: {
    progress: "TOPS aus Deutschland · Die Reise deutscher Handwerkskunst",
    brand: "Markenpräsentation",
    news: "News Room",

    home: "Startseite",
    backTop: "Nach oben"
  },
  pageName: pageName,
  // 精彩案例
  WonderfulCase: {
    title: "Installationsbeispiele",
    model: "Installationsmodell",
    product: "Installationsprodukt",
    productType: "Produkttyp",
    productModel: "Produktmodell",
    productProcess: "Produktprozess",
    nextPage: "Nächste Seite",
    prevPage: "Vorherige Seite",
    titleDetail: "Fall-Details"
  },
  // 字典
  dictionary: {
    bannerList: [
      {
        id: "banner-5",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/1.png"
      },
      {
        id: "banner-1",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/2.png"
      },
      {
        id: "banner-2",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/3.png"
      },
      {
        id: "banner-3",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/4.png"
      },
      {
        id: "banner-4",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/5.png"
      },
      {
        id: "banner-6",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/6.png"
      },
      {
        id: "banner-7",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/1.png"
      }
    ],
    topList: ["Garantie-Anfrage", "HÄNDLER FINDEN", "PREISANFRAGE"],
    navigationList: [
      "ÜBER TOPS",
      "PRODUKTE",
      "LÖSUNGEN",
      "PRODUKT-FALLBEISPIELE",
      "NEWS CENTER",
      "STANDORT"
    ],
    navigationList2: {
      Product: [
        "Lackschutzfolie",
        "G Film (Window Film)",
        "Wrapping Film",
        "Schiebedach-Schutzfolie",
        "TPU Scheinwerferfolie",
        "TPU Windshield Protection Film",
        "Building Glass Functional Film"
      ],
      Solution: ["TRAINING", "HÄNDLER WERDEN", "SOFTWARE"],
      Case: [
        "Lackschutzfolie",
        "G Film (Window Film)",
        "Wrapping Film",
        "Schiebedach-Schutzfolie"
      ],
      Address: [
        "Germany",
        "England",
        "USA",
        "Chinese",
        "Chinese-HK",
        "Japan",
        "Australia",
        "Others"
      ]
    },
    navigationList3: {
      "Solution-train": [" Installationstraining"],
      "Solution-become": ["Händler werden"],
      "Solution-software": ["DAS"]
    },
    developList: [
      {
        unit: "Jahre",
        text: "PPF-Produktionserfahrung"
      },
      {
        unit: "Jahre",
        text: "Scheibenfolien-Produktionserfahrung"
      },
      {
        unit: "",
        text: "Luxusfahrzeuge mit Folienbeklebung"
      },
      {
        unit: "",
        text: "Partnerwerkstätten"
      }
    ],
    progressData: {
      first: {
        title: "Aufbruch",
        content: ["1978 gründete TOPS eine Fabrik in München, Deutschland."]
      },
      second: {
        title: "Anfang",
        content: [
          "2016 wurde das TOPS F&E-Zentrum in München, Deutschland, gegründet.",
          "2018 wurde die Lackschutzfolienmarke TOPS, TOPPF®, auf dem globalen Markt eingeführt.",
          "Im Januar 2019 wurde das TOPS Asia-Pacific-Marketingzentrum in Shanghai, China, gegründet.",
          "Im Juni 2019 wurden vier neue TOPPF® TPU-Lackschutzfolien-Serien weltweit eingeführt.",
          // "In March 2019, TOPPF® brand flagship store was established in Shanghai, China.",
          // "In June 2019, four new series of TOPPF® TPU Lackschutzfolie products were launched globally.",
          // "In August 2019, the brand TOPPF® participated in the CIAIE2019 Shanghai International Automotive Interiors and Exteriors Exhibition in China for the first time."
        ]
      },
      third: {
        title: "Prozess",
        content: [
          "2020 ging TOPS Kooperationen mit der NIO Car Company und anderen Luxusfahrzeuggruppen ein.",
          "Im Januar 2020 wurden die neuen TOPSFilm™ G-Folien (Scheibenfolien) weltweit eingeführt.",
          'Im September 2020 wurde die TOPPF® Schiebedach-Schutzfolie Týr-Serie weltweit eingeführt.',
          "Im Mai 2021 wurde TOPS Color Your Infinity™, die Marke für Wrap-Folien und hochwertige individuelle Lackierfolien unter TOPS, offiziell gegründet.",
          "Im November 2021 ging TOPS eine strategische Partnerschaft mit RAL Colours aus Deutschland ein.",
          // "In May 2021, TOPS Color Your Infinity™, the brand of wrapping film and high-end customized livery film, under TOPS , was officially established.",
          // "In August 2021, TOPS new wrapping film product was launched globally.",
          // "In November 2021, TOPS reached a strategic cooperation with RAL Colours from Germany."
        ]
      },
      fourth: {
        title: "Zukunft·Schreite stets voran"
      }
    },

    brandList: [
      {
        title: "Lackschutzfolie",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%BC%86%E9%9D%A2%E8%86%9Clogo.png",
        content:
          "TOPPF® Lackschutzfolie, verwendet 8mil-10mil optisches TPU+-Material, die vierte Generation V+-Beschichtung, Nano-Kapsel-Technologie, die starke Anti-Verschmutzung, hohe Helligkeit und Vergilbungsbeständigkeit bietet. Deutsche Technologie, Qualitätsgarantie."
        , title1: "TPU Windschutzscheiben-Schutzfolie"
        , content1: "TOPPF® TPU Windschutzscheiben-Schutzfolie, Deutsche Technologie, Qualitätsgarantie, Schützen Sie Ihre Fahrt. Stoss- & kratzfest. Überlegene selbstheilende V+-Beschichtung. Hohe Klarheit, originale Sicht. Externe Installation.",

      },
      {
        title: "G-Folie (Auto-Scheibenfolie)",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E7%AA%97%E8%86%9Clogo.png",
        content:
          "TOPSFilm®  G-Folie (Auto-Scheibenfolie) nutzt TOPS-Kerntechnologie und Nano-Graphen Black-Gold-Material, den König der neuen Materialien und Nobelpreisträger des 21. Jahrhunderts. Hohe Wärmeisolierung, hoher Sonnenschutz, Null Signalstörung und hohe Eignung für Elektrofahrzeuge mit intelligenten Assistenzsystemen."
        , title1: "Funktionsfolie für Gebäudeglas"
        , content1: "Von intelligenter, lichtadaptiver Technologie und Sicherheitsschutz bis hin zu umweltfreundlicher Reinigung und kosteneffizienter Isolierung erfüllt TOPSFilm® Funktionsfolie für Gebäudeglas alle Premium-Anforderungen an das solare Management von Gebäuden.",

      },
      // {
      //   title: "Building Glass Functional Film",
      //   src: "https://img.topsfilm.com/newportal/img/brand/brand-4.png",
      //   bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-4.png",
      //   logo:
      //     "https://img.topsfilm.com/newportal/img/brand/en/%E7%AA%97%E8%86%9Clogo.png",
      //   content:
      //     "From intelligent light-adaptive technology and security protection to eco-friendly purification and cost-efficient insulation, TOPSFilm® Building Glass Functional Film fulfills all the premium requirements for architectural solar management."
      // },
      {
        title: "TOPS Wrapping Film",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%94%B9%E8%89%B2%E8%86%9Clogo.png",
        content:
          "TOPS TPU Wrapping Film verwendet optisches TPU-Substrat, deutsche proprietäre vierte Generation V+-Beschichtung und Nano-Kapsel-Technologie, die das Auto schützen und gleichzeitig die Farbe ändern kann. 12 Farbserien und Hunderte von Farben, strategisch kooperiert mit dem europäischen Jahrhundert-Farbexperten RAL Colour aus Deutschland. Ursprung Deutschland, High-End-Farblösung."
        , title1: "TPU Scheinwerferfolie"
        , content1: "Speziell entwickelt zum Schutz von Autoscheinwerfern vor Abrieb, Steinschlägen und Stössen. Ihr langlebiges, selbstheilendes TPU-Material bewahrt überlegene Klarheit und bietet nachweislichen UV-Widerstand. Vertrauen Sie auf dauerhaften Schutz, untermauert durch eine 10-Jahres-Garantie."

      },
      {
        title: "Color PPF",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%94%B9%E8%89%B2%E8%86%9Clogo.png",
        content:
          "TOPS TPU Color PPF verwendet optisches TPU-Substrat, deutsche proprietäre vierte Generation V+-Beschichtung und Nano-Kapsel-Technologie, die das Auto schützen und gleichzeitig die Farbe ändern kann. 12 Farbserien und Hunderte von Farben, strategisch kooperiert mit dem europäischen Jahrhundert-Farbexperten RAL Colour aus Deutschland. Original aus Deutschland, High-End-Farblösung."
        , title1: "Individuell bedruckte Vinyl-Folie"
        , content1: "Originelles Design, High-End-Anpassung. Trendig und stilvoll, führend in der Lackierfolien-Mode. Original aus Deutschland, High-End-Farblösung."

      },
      {
        title: "Schiebedach-Schutzfolie ",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%BC%86%E9%9D%A2%E8%86%9Clogo.png",
        content:
          "TOPPF®  Schiebedach-Schutzfolie verwendet optische TPU-Träger mit einer Dicke von bis zu 8,5 mil; effiziente Wärmeisolierung und Sonnenschutz; klar und transparent, sicher und explosionsgeschützt; bietet langfristigen Sicherheitsschutz für Auto-Schiebedächer."
      },
      {
        id: "brandList-9",
        title: "Building Glass Functional Film",
        style: {
          padding: "206px 36px 0 85px"
        },
        logo: "https://img.topsfilm.com/newportal/img/brand/logo4.png",
        src: "https://img.topsfilm.com/newportal/img/banner/BGFF.png",
        bgcImg: "https://img.topsfilm.com/newportal/img/banner/BGFF_BG.png",
        content:
          "From intelligent light-adaptive technology and security protection to eco-friendly purification and cost-efficient insulation, TOPSFilm® Building Glass Functional Film fulfills all the premium requirements for architectural solar management."
      },
      {
        id: "brandList-5",
        title: "改色膜",
        style: {
          padding: "204px 36px 0 80px"
        },
        logo: "https://img.topsfilm.com/newportal/img/brand/logo4.png",
        src: "https://img.topsfilm.com/newportal/img/banner/ColorPPF.png",
        bgcImg: "https://img.topsfilm.com/newportal/img/banner/ColorPPF_BG.png",
        content:
          "TOPS拓弗改色膜采用德国铸造级颜色层，创新光学保护膜层，以及创新聚氯乙烯膜技术，多元化呈现色彩质感与饱和度；TOPS拓弗改色膜与德国百年色彩研究机构RAL劳尔色彩达成战略合作，以源自德国、高端配色作为产品定位，以Color Your Infinity色无止境作为品牌理念，为用户提供奢享版、尊享版、经典版三大版本，共12个色系，百余款高端潮流改色方案。TOPS拓弗改色膜奢享版TPU改色膜，采用TPU基材，创新色彩涂层涂敷工艺，采用第四代V+涂层纳米胶囊技术，具有高倍韧性和自修复能力，提供改色和保护双重功效。      "
          , title1: ""//TPU Headlight Film
          ,content1:""//"Engineered specifically to shield car headlights from abrasion, chips, and impacts. Its durable, self-healing TPU material maintains superior clarity and offers proven UV resistance. Trust in lasting protection, backed by a 10-year warranty."

      }
    ],

    footerData: {
      product: {
        title: "Produktzentrum",
        content: [
          "Lackschutzfolie",
          "G Film (Window Film)",
          "Wrapping Film",
          "Schiebedach-Schutzfolie",
          "TPU Scheinwerferfolie",
          "Building Glass Functional Film"
        ]
      },
      Solution: {
        title: "Lösung",
        content: [
          // "TRAINING",

          " Installationstraining",
          // "SOFTWARE",
          "DAS (Data Assist System)"
        ]
      },
      case: {
        title: "Installationsbeispiele",
        content: [
          "Lackschutzfolie",
          "G Film (Window Film)",
          "Wrapping Film",
          "Schiebedach-Schutzfolie"
        ]
      },
      // help: {
      //   // title: "Help",
      //   // content: []
      // },
      brand: {
        title: "NEWS CENTER",
        content: ["News Room"]
      }
    },
    dASData: {
      first: {
        title: "DAS DATA ASSIST SYSTEM",
        content: [
          "In-house entwickelt, ist unser DAS (DATA ASSIST SYSTEM) das weltweit größte und umfassendste Muster-Repository mit über 140.000 Fahrzeugdatenmodellen. In den Händen eines TOPS-zertifizierten Installateurs bieten die vom DAS bereitgestellten Muster das nötige Vertrauen, um Folien effizient, präzise und ohne Bedenken anzubringen. Nachdem Sie unser offizieller Partner geworden sind, bieten wir Ihnen eine kostenlose 2-wöchige Testphase an, damit Sie sehen können, wie die Präzision unserer DATA ASSIST SYSTEM-Muster Ihrem Geschäft zum Erfolg verhelfen kann."
        ]
      },
      second: {
        title: "LACKSCHUTZFOLIEN-MUSTER",
        content: [
          "Seit den frühen Tagen von TOPS sind Lackschutzfolien-Muster ein Eckpfeiler unseres Unternehmens. Das DATA ASSIST SYSTEM ermöglicht es Ihnen, sofortige Kontrolle über das größte Muster-Repository des Planeten zu haben. Das DAS bietet auch eine sichere, risikofreie Installationslösung, da es die Notwendigkeit und Gefahren des manuellen Schneidens eliminiert, Installationszeiten reduziert und die Effizienz um 70% verbessert.",
          "Derzeit enthält das DAS fast 140.000 Lackschutzfolien-Kits für praktisch jedes erdenkliche Marken- und Modell. Alle Kits werden mit bestmöglicher Passform und Funktionalität im Hinterkopf entwickelt."
        ]
      },
      third: {
        title: "LACKSCHUTZFOLIEN-MUSTER",
        content: ["TOUR PlUS,TOUR,PHANTOM MATTE,PHANTOM,FEDER"]
      },
      fourth: {
        title: "Präzisionsmuster",
        content: [
          "Ein Softwarepaket mit vielen Extras ist schön, aber seien wir ehrlich - was wirklich den Unterschied zwischen einem Programm und einem anderen ausmacht, ist die Qualität der Designs. Bei TOPS sind unsere zwei primären Designziele, die Folie so natürlich wie möglich auf dem Auto zu platzieren, um unnötige Dehnung und Verzerrung zu vermeiden, und eine perfekte Ausrichtung mit den Karosserieteilen sicherzustellen.",
          "Zusätzlich zu diesen beiden primären Zielen ist unser Designteam auch darauf bedacht, Designs bereitzustellen, die absolut keine unnötigen Nähte oder Entlastungen verwenden. Und wenn eine Naht benötigt wird, um ein besonders komplexes Teil zu navigieren, werden unsere Designer alles Mögliche tun, um sie an einer Karosserielinie oder an einem Teil des Panels zu verstecken, der außer Sicht ist.",
          "Die Installation von richtig designten vorgeschnittenen Kits kann den Unterschied zwischen Erfolg und Misserfolg im Lackschutzfolien-Geschäft ausmachen. Fordern Sie noch heute Ihre kostenlose 30-Tage-Testversion an, um zu sehen, wie wir Ihnen zum Erfolg verhelfen können."
        ]
      },
      fifth: {
        title: "Aktuellste Verfügbarkeit",
        content: [
          "Da die Teams von TOPS-Produktingenieuren täglich daran arbeiten, Designvorlagen für neue Fahrzeuge zu erstellen, sind diese Produkte sofort in der Software verfügbar, sobald sie fertiggestellt sind. Kein Warten auf Update-Pakete, die versendet werden müssen, oder Downloads, die abgeschlossen werden müssen. Verwenden Sie einfach die bequeme Suchoberfläche in der Software und jedes Muster, neu und alt, ist in Echtzeit verfügbar, sobald es verfügbar ist."
        ]
      },
      sixth: {
        title: "Variable Geometrie",
        content: [
          "Das richtige Muster zu haben, wenn Sie es brauchen, ist nur ein Teil der Gleichung. Um die vollständige Kundenzufriedenheit unabhängig von Budget oder Erwartungen sicherzustellen, benötigen Sie ein Schneidprogramm mit ernsthafter Flexibilität.",
          "Mit unserer patentierten Variable Geometry-Funktionalität können Sie sicher und schnell praktisch jede Variation von Abdeckungsdetails implementieren, um sicherzustellen, dass Ihre Kunden die Qualität erhalten, die sie erwarten, zu einem Preis, den sie sich leisten können. Umhüllen Sie jede Kante, ändern Sie die Abdeckungsmenge oder sogar die Designelemente eines Musters, ohne die Möglichkeit, versehentlich Änderungen vorzunehmen, die das Teil unbrauchbar machen würden."
        ]
      },
      seventh: {
        title:
          "WEITERE INFORMATIONEN ANFRAGEN<br/>Haben Sie eine Frage zu TOPS's DATA ASSIST SYSTEM?<br/>Verwenden Sie das Kontaktformular unten:",
        content: ["DAS HERUNTERLADEN"]
      }
    }
  },
  product: {
    productCenter: "PRODUKTZENTRUM",
    viewDetail: "Details anzeigen",
    paintTitle: 'TOPPF® Lackschutzfolie "GERMAN" Standard',
    ppf: "Lackschutzfolie",
    windowFilm: "Fensterfolie",
    QA: val => {
      return `Garantiezeitraum: ${val} Jahre`;
    },
    standard: "Standard",
    germany: "Deutsch",

    parameter: "Produktparameter",
    tableDic: {
      model: "Produkttyp",
      visibleLightTransmittance: "VLT",
      totalSolarBarrier: "TSR",
      reflectiveRate: "RR",
      UVBarrier: "UV",
      "5gSignalPassRate": "5G",
      thickness: "Dicke",
      warrantyPeriod: "Garantiezeitraum"
    },
    tableDic2: {
      visibleLightTransmittance: "VLT",
      totalSolarBarrier: "TSR",
      infraredBarrierRatio: "IBR",
      UVBarrier: "UV",
      "5gSignalPassRate": "5G",
      thickness: "Dicke",
      warrantyPeriod: "Garantiezeitraum"
    }
  },
  dynamic: {
    hot: "Empfohlene Themen",
    refresh: "Aktualisieren"
  },
  "pruduct-dict": {
    trait: [
      {
        title: "Hohe Helligkeit",
        text:
          "Deutsche innovative V+-Beschichtungstechnologie kann die Helligkeit des Original-Lacks um mehr als 30% effektiv erhöhen; TPU-Substrat hat hohe Elastizität, kann effektiv gegen Steinschläge verteidigen und kleine Reibungskratzer automatisch reparieren; hält die Karosserie glänzend und schön und schützt die Lackoberfläche ohne Spuren wie neu."
      },
      {
        title: "Starke Anti-Verschmutzung",
        text:
          "Nano-Kapsel-Technologie, Anti-Verschmutzungs-Technologie, kombiniert mit bionischen Prinzipien, schafft starke Anti-Staub- und Anti-Haft-Fähigkeiten, hydrophobische Selbstreinigung, Anti-Verschmutzung und Anti-Kalk."
      },
      {
        title: "Vergilbungsbeständigkeit",
        text:
          "Es verwendet optisches TPU+-Substrat, um ultraviolette Strahlung zu blockieren, Anti-Oxidation und hohe Temperatureinwirkung, schützt effektiv die Textur und den Glanz des Original-Lacks und verhindert Alterung und Verblassen."
      }
    ],

    vbot:
      "Der leitende Beschichtungs-Entwicklungsingenieur von TOPPF kommt vom weltbekannten deutschen Beschichtungsunternehmen BASF. Mit Unterstützung der Entwicklungsabteilung des deutschen Chemieunternehmens Bayer entwickelte er erfolgreich eine proprietäre Vierte-Generation-V+-Beschichtungs-Nano-Kapsel-Technologie. TOPPF's proprietäre V+-Beschichtung hat 9.600 Stunden strenge Alterungstests im Labor durchlaufen und kann die Helligkeit des Original-Lacks um mehr als 30% effektiv erhöhen, wodurch der Autolack so hell wie neu bleibt.",

    productNameDic: {
      Paint: "Lackschutzfolie",
      G: "G Film (Fensterfolie)",
      ColorChange: "Wrapping Film",
      Colorful: "Bunte Folie",
      SkyLight: "Schiebedach-Schutzfolie",
      Headlight: "TPU Scheinwerferfolie",

    },

    // 漆面保护膜
    //    漆面详情
    paintDetailList: [
      {
        "text-cn": "TOUR PLUS",
        title: "TOP ONE",
        content:
          "Es verwendet TOPPF's vierte Generation V+-Beschichtung mit Nano-Kapsel-Technologie und TPU+10mil verdicktes Substrat, bietet ultimativen Schutz. Es hat Super-Elastizität, Hochleistungs-Korrosionsbeständigkeit, Selbstreparatur, Anti-Verschmutzung, Anti-Kratz und hohe Helligkeit."
      },
      {
        "text-cn": "TOUR",
        title: "Premium-Qualität",
        content:
          "Verwendet die vierte Generation V+-Beschichtung von Deutschland Tofer, Nano-Kapsel-Technologie und optisches TPU+-Hochqualitäts-Substrat. Es hat die Eigenschaften hoher Korrosionsbeständigkeit, Selbstreparatur, Anti-Verschmutzung, Anti-Kratz und hoher Helligkeit."
      },
      {
        "text-cn": "PHANTOM MATTE",
        title: "Luxus und Elegant",
        content:
          "Es hat eine matte Satin-Textur, hergestellt aus der gleichen TOPPF's vierten Generation V+-Beschichtung mit Nano-Kapsel-Technologie und Gieß-Matte-Prozess wie die PHANTOM-Serie, bietet außergewöhnlichen Schutz für die Karosserie und zeigt Eleganz."
      },
      {
        "text-cn": "PHANTOM",
        title: "High-End-Spieler",
        content:
          "Hochtransparente und helle Lackschutzfolie, verwendet TOPPF's vierte Generation V+-Beschichtung mit Nano-Kapsel-Technologie, ihre Hauptmerkmale sind hohe Helligkeit, starke Anti-Verschmutzung und Vergilbungsbeständigkeit."
      },
      {
        "text-cn": "FEDER",
        title: "Beste Wahl",
        content:
          "PDI-Kanal-exklusives Produkt, verwendet TOPPF's vierte Generation V+-Beschichtung mit Nano-Kapsel-Technologie, kann verschiedenen Verschmutzungen widerstehen, hohe Transparenz, blendend, langlebig und stabil, verbessert effektiv den Glanz des Original-Lacks. Es ist die beste Wahl für PDI-Kanal-Partner."
      },
      {
        "text-cn": "F1",
        title: "Handwerkskunst",
        content:
          "Verwendet TOPPF's vierte Generation V+-Beschichtung mit Nano-Kapsel-Technologie, ist vergilbungsbeständig, einfach anzubringen, selbstreparaturfähig bei Raumtemperatur, gutes Preis-Leistungs-Verhältnis und wird von Geschäften bevorzugt."
      }
    ],
    //    漆面展示
    paintStandardList: [
      {
        "text-cn": "Dazzling-enhance gloss",
        content:
          "Deutsche proprietäre vierte Generation V+-Beschichtung und Nano-Kapsel-Technologie, hohe blendende Helligkeit, hohe Klarheit, verbessert effektiv den Oberflächenglanz des Original-Lacks um mehr als 30%."
      },
      {
        "text-cn": "Anti-fouling-insulates against pollution",
        content:
          "Deutsche proprietäre vierte Generation V+-Beschichtung und Nano-Kapsel-Technologie, starke Anti-Staub-Fähigkeit und Anti-Haft-Fähigkeit, verhindert, dass Vogelkot und Staub in der Atmosphäre korrodieren, und schützt effektiv den Original-Lack vor Schäden."
      },
      {
        "text-cn": "No trace-as long as new",
        content:
          "Kräftige Selbstreparaturfunktion, kleine Kratzer können automatisch repariert werden, hält die Lackoberfläche effektiv wie neu."
      },
      {
        "text-cn": "Color protection-prevent fading",
        content:
          "Blockiert 98% UV, effektiver Schutz des Original-Lacks, Anti-Alterung und Verblassen."
      },
      {
        "text-cn": "Protection - resist scratches",
        content:
          "Optisches TPU+-Basismaterial, superelastisch, verteidigt effektiv gegen Kratzer und Steinschläge und schützt den Original-Autolack vor Schäden."
      },
      {
        "text-cn": "Clean-self-cleaning and anti-fouling",
        content:
          "Deutsche proprietäre vierte Generation V+-Beschichtung und Nano-Kapsel-Technologie, hervorragende hydrophobe und selbstreinigende Funktion, verhindert effektiv Kalkablagerungen auf dem Autolack."
      }
    ],

    // G速膜
    GData: {
      Dynamic: {
        title: "DYNAMIC SERIES",
        content: [
          {
            id: "Dynamic-1",
            model: "CW75-30",
            thickness: " Dicke: 5mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:75%-30%",


          },
          {
            id: "Dynamic-2",
            model: "CW60-15",
            thickness: " Dicke: 4mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:60%-15%"
          }
        ],
        topText:
          "Die Dynamic Series™-Serie nutzt TOPS's proprietäre Technologie, um intelligente Helligkeitsänderung mit der Lichtintensität zu erreichen. Es blockiert keine 5G-Signale bei effizienter Wärmeisolierung, sicherer Explosionsschutz und UV-Isolation. 10-Jahre Werksgarantie.",
        botTitle: "Vorteile von <br/> Dynamic Series™-Produkten",
        botAdvantage: [
          { title: "Talentiert", text: "Intelligenter Blendeschutz für jede komfortable Fahrt;" },
          { title: "Hervorragend", text: "Mikro-Level-Helligkeits- und Transparenzanpassung;" },
          { title: " Prestigeträchtig", text: "Lichtabhängig veränderlich, komfortabel und angenehm;" },
          { title: "Sicherheit", text: "Schnelle Reaktion, intelligent und sicher;" },
          { title: " Flexibel", text: " Schützen Sie die Augen ohne Angst vor starkem Licht." }
        ],
        slogan: "- Unendliche Sicht, intelligente Helligkeit",
      },
      SuperDiamond: {
        title: "SUPER DIAMOND SERIES",
        content: [
          {
            id: "SuperDiamond-1",
            model: "T80",
            thickness: " Dicke: 4mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:80%",

          },
          {
            id: "SuperDiamond-2",
            model: "T40",
            thickness: " Dicke: 4mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:38%"
          },
          {
            id: "SuperDiamond-3",
            model: "T15",
            thickness: " Dicke: 4mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:15%"
          }
        ],
        topText:
          "Super Diamond Series verwendet TOPS's patentierte Nano-Graphen-Schwarzgold-Folien-Schicht, die keine Signalblockierungsstörungen hat, nicht-metallisches Material, 100% Nicht-Oxidation, konstante Farbe und keine Verblassungs-Sorgen. Es verwendet nicht-metallische 'Folien'-Technologie und ermöglicht vollständige Übertragung von Mobiltelefon/GPS/ETC-Signalen, was für den High-Tech-Smart-Transport im 5G-Zeitalter wichtig ist, hoch angepasst an Elektrofahrzeuge und Begleiter für die vollständige Öffnung der autonomen Fahrtechnologie. Hohe Lichtdurchlässigkeit, hohe Auflösung, niedrige Reflexion, bietet die klarste Frontsicht, gewährleistet sicheres Fahren bei Nacht. 10-Jahre Werksgarantie, langlebig und dauerhaft.",
        botTitle: "Vorteile von Super Diamond Series-Produkten",
        botAdvantage: [
          { text: "Null Blockierung von 5G-Signalen, präzises Andocken für Smart Travel. " },
          { text: "Schwarzgold-Sicherheitsnetz, High-Tech-Schutz." },
          { text: " Top-Wärmeisolierung, starker Sonnenschutz. " },
          { text: "Hohe UV-Isolation, reduziert die Schäden durch Photo-Alterung. " },
          { text: "Hohe Auflösung, ungehinderte Sicht." },
          { text: " Keine Oxidation, langlebig. Garantie 10-Jahre Werksgarantie." }
        ],
        slogan: "- Schwarzgold-Technologie, genussvolles Leben",
      },
      Diamond: {
        title: "DIAMOND SERIES",
        content: [
          {
            id: "Diamond-1",
            model: "O80",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:80%"
          },
          {
            id: "Diamond-4",
            model: "O35",
            thickness: "Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:36%",

          }

        ],
        special: [

          {
            id: "Diamond-2",
            model: "O25",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:20%"
          },
          {
            id: "Diamond-3",
            model: "O15",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:15%"
          },
          {
            id: "Diamond-5",
            model: "O05",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:10 Jahre",
            visibleLightTransmittance: "VLT:5%",

          }
        ],
        topText:
          "Diamond Series verwendet TOPS's patentierte Nano-Graphen-Schwarzgold-Folien-Schicht, die keine Signalblockierungsstörungen hat, nicht-metallisches Material, 100% Nicht-Oxidation, konstante Farbe und keine Verblassungs-Sorgen. Es verwendet nicht-metallische 'Folien'-Technologie und ermöglicht vollständige Übertragung von Mobiltelefon/GPS/ETC-Signalen, was für den High-Tech-Smart-Transport im 5G-Zeitalter wichtig ist, hoch angepasst an Elektrofahrzeuge und Begleiter für die vollständige Öffnung der autonomen Fahrtechnologie. Hohe Lichtdurchlässigkeit, hohe Auflösung, niedrige Reflexion, bietet die klarste Frontsicht, gewährleistet sicheres Fahren bei Nacht. 10-Jahre Werksgarantie, langlebig und dauerhaft.",
        botTitle: "Vorteile von Diamond Series-Produkten",
        botAdvantage: [
          { text: "Null Blockierung von 5G-Signalen, präzises Andocken für Smart Travel." },
          { text: "Schwarzgold-Sicherheitsnetz, High-Tech-Schutz." },
          { text: "Top-Wärmeisolierung, starker Sonnenschutz." },
          { text: "Hohe UV-Isolation, reduziert die Schäden durch Photo-Alterung." },
          { text: "Hohe Auflösung, ungehinderte Sicht. Keine Oxidation, langlebig." },
          { text: "Garantie 10-Jahre Werksgarantie." },
        ],
        slogan: "- Kristall-Fensterfolie, strahlendes Leben",

      },
      Crystal: {
        title: "CAYSTAL SERIES",
        content: [
          {
            id: "Crystal-1",
            model: "S75",
            thickness: " Dicke: 2.5mil",
            warrantyPeriod: "Garantiezeitraum:5 Jahre",
            visibleLightTransmittance: "VLT:75%"
          },
          {
            id: "Crystal-2",
            model: "S35",
            thickness: " Dicke: 2.5mil",
            warrantyPeriod: "Garantiezeitraum:5 Jahre",
            visibleLightTransmittance: "VLT:35%"
          },
          {
            id: "Crystal-3",
            model: "S15",
            thickness: " Dicke: 2.5mil",
            warrantyPeriod: "Garantiezeitraum:5 Jahre",
            visibleLightTransmittance: "VLT:15%"
          }
        ],
        topText:
          "Die Crystal Series verwendet TOPS's patentierte Nano-Graphen-Schwarzgold-Folien-Schicht, die keine Signalblockierungsstörungen hat; sie hat einzigartige spektrale selektive Reflexion, hocheffiziente Wärmeisolierung, reduziert schnell und effektiv die Temperatur im Auto und verbessert umfassend den Fahrkomfort. Sie trennt die Welt aus Eis und Feuer mit einer Folie und schafft ein kühles und erfrischendes Autoleben. Sie blockiert effektiv 99,9% der ultravioletten Strahlen und bietet einen Sonnenschutzwert, der SPF1000+ entspricht, was 30 Mal der Sonnenschutzwert von täglichen Sonnenschutz-Hautpflegeprodukten ist. Sie schützt effektiv die Hautgesundheit und das Verblassen und Altern des Interieurs Ihres Autos, während sie effektiv die Schäden durch ultraviolette Strahlen an den Augen reduziert und die Gesundheit und Sicherheit Ihrer Familie schützt. 5-Jahre Werksgarantie, keine Oxidation und langlebig.",
        botTitle: "Vorteile von Crystal Series-Produkten",
        botAdvantage: [
          { text: "5G-Signal Null-Blockierung, präzises Andocken für Smart Travel." },
          { text: "Vollständiger Hautschutz, starker Sonnenschutz." },
          { text: "100% ultraviolette Isolation, reduziert die Schäden durch Lichtalterung." },
          { text: "Hohe Auflösung, ungehinderte Sicht." },
          { text: "Keine Oxidation, langlebig. " },
          { text: "5-Jahre Werksgarantie." },
        ],
        slogan: "- Kristall-Fensterfolie,  angenehmes Leben",
      },
      //F70 F30 F20 F10
      F: {
        // F系列
        id: "G-5",
        title: "CRYSTAL ENJOYMENT SERIES",
        src:
          "https://img.topsfilm.com/newportal/img/product/G/color-bound-jingyao.png",
        content: [
          {
            id: "F-70",
            model: "F70",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:7 Jahre",
            visibleLightTransmittance: "VLT:70%"

          },
          {
            id: "F-30",
            model: "F30",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:7 Jahre",
            visibleLightTransmittance: "VLT:30%"

          },
          {
            id: "F-20",
            model: "F20",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:7 Jahre",
            visibleLightTransmittance: "VLT:20%"

          },
          {
            id: "F-10",
            model: "F10",
            thickness: " Dicke: 2mil",
            warrantyPeriod: "Garantiezeitraum:7 Jahre",
            visibleLightTransmittance: "VLT:10%"

          },
        ],
        topText: "Crystal Enjoyment Series verwendet TOPS's patentierte Nano-Graphen<br/> Schwarzgold-Folien-Schicht, die keine Signalblockierungsstörungen hat, nicht-metallisches Material, 100% Nicht-Oxidation, konstante Farbe und keine Verblassungs-Sorgen. Sie verwendet nicht-metallische 'Folien'-Technologie und ermöglicht vollständige Übertragung von Mobiltelefon/GPS/ETC-Signalen, was für den High-Tech-Smart-Transport im 5G-Zeitalter wichtig ist, hoch angepasst an Elektrofahrzeuge und Begleiter für die vollständige Öffnung der autonomen Fahrtechnologie. Hohe Lichtdurchlässigkeit, hohe Auflösung, niedrige Reflexion, bietet die klarste Frontsicht, gewährleistet sicheres Fahren bei Nacht. 7-Jahre Werksgarantie, langlebig und dauerhaft.   ",
        botTitle: "Vorteile von Crystal Enjoyment Series-Produkten",
        botAdvantage: [
          { text: "5G-Signal Null-Blockierung, präzises Andocken für Smart Travel." },
          { text: "99% ultraviolette Isolation, reduziert die Schäden durch Lichtalterung." },
          { text: "Hohe Auflösung, ungehinderte Sicht." },
          { text: "Keine Oxidation, langlebig. " },
          { text: "7-Jahre Werksgarantie." },
        ],
        slogan: "- Kristall-Fensterfolie,  angenehmes Leben",

      }
    },
    //     窗膜
    windowMembraneList: {
      titlesrc: "https://img.topsfilm.com/newportal/img/product/G/en-GGG.png",
      newenergySrc: "https://img.topsfilm.com/newportal/img/product/G/newenergy2En.png",
      content: [
        "",
        "Null Blockierung von 5G-Signalen,<br/>präzises Andocken und intelligentes Reisen.",
        "Nano-Graphen-Schwarzgold-Material, <br/>High-Tech-Schutz.",
        "Top-Wärmeisolierung, starker Sonnenschutz.",
        "Hohe UV-Isolation,<br/>Reduziert die Schäden durch Photoalterung.",
        "Hohe Auflösung, ungehinderte Sicht.",
        "Keine Oxidation, langlebig.",
        "Garantie bis zu 10-Jahre Werksgarantie."
      ]
    },
    // 改色膜
    colorChangeData: {
      series: {
        classic: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/classic-colorful.png",
          data: [
            "Genesis Grey Space Series",
            "Dark Gothic Series",
            "Splendid Galaxy Series",
            "Inspirational Muse Series",
            "Illusory Europe Series",
            "Impressional France Series",
            "Duke Deluxe Series",
            "Glamorous Queens Series",
            "Romantic Venus Series",
            "Fantastic Van Gogh Series"
          ]
        },
        enjoy: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/enjoy-colorful.png",

          data: [
            "Genesis Grey Space Series",
            "Dark Gothic Series",
            "Splendid Galaxy Series",
            "Golden Flame Series",
            "Saint Violet Series",
            "Impressional France Series",
            "Duke Deluxe Series",
            "Glamorous Queens Series",
            "Romantic Venus Series",
            "Fantastic Van Gogh Series"
          ]
        },
        luxurious: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/luxurious-colorful.png",

          data: [
            "Munich Series",
            "Berlin Series",
            "Hamburg Series",
            "Rhine Series",
            "Cologne Series",
            "Stuttgart Series"
          ]
        },
        custom: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/custom-colorful.png",

          data: [
            "Kategorie A Teilweise einfache Folien-Lackierung",
            "Kategorie B Vollständige einfache Folien-Lackierung",
            "Kategorie C Vollständige Folien-Lackierung",
            "Kategorie D Vollständige komplizierte Folien-Lackierung"
          ]
        }
      },
      membrane: {
        1: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/colorfultext.png",
          text:
            "RAL Colours from Germany Exclusive Design<br/> RAL X TOPS <br/>TOPS & RAL Colours Agreed On A Long-term Exclusive Strategic Cooperation"
        },
        2: {
          title: "Über RAL Colours",
          "text-t":
            "Gegründet 1925, ist RAL ein deutsches Unternehmen mit einer fast 100-jährigen Geschichte. RAL Colours hat viele Weltneuheiten und einzigartige Technologien im Bereich der Farbstandardisierung und ist die Kommunikationssprache der Farbwelt, die weltweit verwendet wird.",
          "text-b":
            "Bis heute ist RAL Colours zum Synonym für das globale Farbsystem und Farbklassifizierungssystem geworden, das in den Augen professioneller Farbdesigner unabhängig von Herstellern ist. RAL Colours hat insgesamt 2.328 Farben, und seine Produkte umfassen fächerförmige Farbkarten, Original-Farbstandards, Kunststoff-Farbstandards, Farb-Digitalisierungs-Software sowie Farbdesign- und Trendbücher. In vielen Industriebereichen wie Autolacken und Karosseriebeschichtungen wird RAL Colours als autoritativer Farbstandard verwendet."
        }
      },
      perfect: [
        {
          // "logo-text":
          //   "TOPS & RAL Colours Agreed On A Long-term Exclusive Strategic Cooperation"
        }
      ]
    },

    // 天窗膜
    skylightData: {
      series: [
        {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/public/logoEn.png",
          text: "TOPPF Schiebedach-Schutzfolie<br/>TYR Series",
          detail: {
            title: "TOPPF Schiebedach <br/> Schutzfolie TYR Serie",
            weilai: {
              title:
                "TOPPF——Der exklusive benannte Lieferant von Schiebedach-Wärmedämmfolien für NIO",
            },
            maxList: [
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-1.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-2.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-3.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-4.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-5.png"
            ]
          }
        }
      ],
      membrane: [
        "TOPPF——Der exklusive benannte Lieferant von Schiebedach-Wärmedämmfolien für NIO",
        `'<div>Safety MAX</div><br/><span class="text">sicher und explosionsgeschützt, zuverlässiger Schutz</span>`,
        `<div>Sun-protection MAX</div><br/><span class="text">Effizienter Sonnenschutz, erhält eine kühle Umgebung und schützt Ihre Haut</span>`,
        `<div>Coolness MAX</div><br/><span>Schnell abkühlen, schaffen Sie ein komfortables Fahrerlebnis</span>`,
        `<div>Clarity MAX</div><br/><span class="text">Selbstreparaturfähigkeit, erhält eine klare und transparente Sicht</span>`,
        `<div>Speed MAX</div><br/><span class="text">Kein Warten nötig, kleben und losfahren</span>`
      ]
    }
  },
  help: {
    name: "Name",
    city: "Stadt",
    lastName: "Nachname",
    province: "Region",
    companyName: "Firmenname",
    country: "Land",
    email: "E-Mail",
    zipCode: "Postleitzahl",
    phone: "Telefon",
    adress: "Adresse",
    addressTwo: "Adresse 2",
    content: "Anfragedetails",
    submit: "Absenden",
    resetForm: "Formular zurücksetzen",
    formTitle: "Informationstabelle",
    formdes: "Erforderliche Informationen*"
  },
  train: {
    title: "Verpflichtung zur Installationsqualität",
    text:
      "Die Verpflichtung, den Kunden qualitativ hochwertige Installationen von TOPPF-Produkten anzubieten, ist äußerst wichtig für Ihren Erfolg in der Lackschutzfolien-Industrie. Aus diesem Grund bietet TOPPF einen sehr gründlichen Satz von Installationsschulungskursen an, die durchweg als die besten in der Branche bewertet wurden.",
    text1:
      "Wir führen unsere Auszubildenden durch einen professionellen Prozess, der sowohl intellektuell als auch praktisch ist. Unser umfassendes PPF-Installationsschulungsprogramm deckt Themen ab, die von den inneren Abläufen unserer DAS-Software bis zu den neuesten, innovativsten Installationstechniken für Lack- und Scheinwerferschutzfolien reichen.",
    callingText: "Bitte senden Sie eine E-Mail an ",


    knowMore: "um mehr zu erfahren oder Ihre Klasse zu planen.",
    trainingclass: "SCHULUNGSKLASSEN",
    courseList: [
      {
        id: "course-1",
        title: "Schulungsklasse",
        content: [
          "Installationstraining",
          "Meister-Training",
          "Meister-der-Meister-Training"
        ]
      },
      {
        id: "course-2",
        title: "Dauer",
        content: ["Vier(4) Tage", "Drei(3) Tage", "Zwei(2) Tage"]
      },
      // {
      //   id: "course-3",
      //   title: "Cost",
      //   content: ["€600", "€500", "€400"]
      // }
    ],
    installationTrainingTitle: "Installationstraining",
    installationTrainingContent:
      "Wir bieten alle Klassen im TOPPF-Schulungszentrum an, das in Deutschland und Shanghai, China, liegt. Unser PPF-Installationstraining kommt sowohl Anfängern als auch fortgeschrittenen Installateuren zugute, mit einem gezielt strukturierten Lehrplan für jedes Können. Auszubildende erhalten persönliche Aufmerksamkeit, die es ihnen ermöglicht, die notwendigen Fähigkeiten zu erlangen, um qualitativ hochwertige, störungsfreie Installationen auch bei den anspruchsvollsten Fahrzeugen zu gewährleisten.",
    installationTrainingContent1:
      "Wir bieten auch vollständige Anweisungen zur Verwendung unserer Data Assist System (DAS)-Software und zugehöriger Hardware. Wir werden Sie mit einem Schulungshandbuch, allen notwendigen Materialien und Werkzeugen versorgen. Um eine angemessene Menge an spezialisierter Aufmerksamkeit sicherzustellen, sind die Klassengrößen normalerweise auf vier Auszubildende pro Ausbilder begrenzt.",
    installationTrainingContent2:
      "Wenn Sie weitere Informationen wünschen, senden Sie bitte eine E-Mail an info@topsfilm.com, um sich mit einem Firmenvertreter zu beraten.",
    internationalTrainingAvailable: "INTERNATIONALE SCHULUNG VERFÜGBAR",
    gcompanyName: "TOPS Germany",
    gadress: "Theresienhoehe 28, München, Deutschland",
    gphone: "+49 89 24440 7026",
    gworkTime: "9:00-6:00 CST",
    gdes:
      "Der deutsche Hauptsitz von TOPS befindet sich in Theresienhoehe 28, München, Deutschland, und bietet Schulungen für Kunden in allen Regionen an.",
    formTitle:
      "WEITERE INFORMATIONEN ANFRAGEN<br/>Haben Sie eine Frage zu TOPPF PPF Installationstraining?<br/>Verwenden Sie das Kontaktformular unten:"
  },
  joinDealer: {
    formTitle:
      "WEITERE INFORMATIONEN ANFRAGEN<br/>Haben Sie eine Frage zu TOPS Händler werden?<br/>Verwenden Sie das Kontaktformular unten:",
    title: "Bieten Sie den Menschen, was sie brauchen. TOPS ist die Wahl der Enthusiasten.",
    content:
      "TOPS-Produkte, die sich der Branchenführung widmen, haben die Art und Weise neu definiert, wie die Öffentlichkeit über High-Performance-Schutz und Präzisions-Folieninstallationen denkt. Mit Wurzeln im Mustermuster-Design und Softwareentwicklung sind wir bestrebt, die Rentabilität unserer professionellen Installateure zu steigern und die Renditen zu maximieren. Wir sind bereit, Ihr Geschäft auf die nächste Stufe zu bringen mit unseren fortschrittlichen Automotive-, Wohn- und Gewerbefensterfolien, Lackschutzfolie, Installationswerkzeugen, Nachsorgeprodukten und den umfassendsten Schulungsprogrammen in der Branche.",
    nmoreInfo: " WEITERE INFOS↓",
    findDealer: "HÄNDLER FINDEN",

    dealerPhotop: "Händler im Rampenlicht",
    success: "Wir bereiten Sie auf den Erfolg vor",
    successDes:
      "Hier bei TOPS investieren wir stark in die Unterstützung unserer Familie professioneller Installateure, ihre Geschäftsziele auf dem Weg zum langfristigen Erfolg zu erreichen.",
    advantageTitle: "Vorteile als Händler:",
    advantageList: [
      "Hochrangige Positionierung in Top-Suchmaschinenergebnissen dank unseres einzigartigen Installateur-Locators.",
      "Sofortige Verbindung zum globalen Kundenserviceteam von TOPS, 24 Stunden am Tag und 7 Tage die Woche.",
      "Ein engagierter Vertriebsprofi, der Ihnen hilft, Ihre Geschäftstätigkeiten im Einzelhandels- und Großhandelsmarkt zu steigern.",
      "Zugang zu Marken- und Marketingressourcen, um das Gesicht Ihres Unternehmens persönlich und online zu transformieren."
    ],
    curx: "SCHLÜSSEL ZUM ERFOLG",
    curxtitle: "Unvergleichliches Training",
    curxcontent:
      "Top-Installationen beginnen mit einem starken Fähigkeitensatz. Hier bei TOPS bieten wir das höchstbewertete und umfassendste Schulungsprogramm in der Branche. Mit vielen Jahren Erfahrung in der Folieninstallationsschulung bietet unser Zertifizierungsprogramm Ihnen die Wissensbasis, die Sie benötigen, um Ihre Reise zu beginnen.",

    curxtitle1: "Maßgeschneiderte Software",
    curxcontent1:
      "Als Schöpfer und Innovatoren von vorgeschnittenen Kits wird Ihnen unser weltbekanntes Data Assist System (DAS) helfen, der Konkurrenz einen Schritt voraus zu bleiben mit maximaler Effizienz. Bestehend aus über 140.000 Mustern und wachsend, ermöglicht Ihnen das DAS, Ihren Kunden das Maß an Präzision zu bieten, das sie sich wünschen."
  },
  distributor: {
    title: "Einen autorisierten TOPS-Händler finden",
    country: "BEZIRK/KREIS",
    select: "--AUSWÄHLEN--",
    province: "VERTRIEBSPARTNER",
    city: "STADT",
    noresult: "Keine Daten",
    query: "Abfrage",
    queryMap: "Karte"
  },
  bottomNavigation: {
    title: "Kontaktieren Sie uns:",
    edAdressTitle: "Globaler Hauptsitz",
    edAdress: "Professor-Messerschmitt-Str. 3a, 85579 Neubiberg, Germany",
    adressTitle: "Asien-Pazifik-Hauptsitz",
    adress:
      "Adresse: Building C3 , No 689 , Guanghua Rd. Minhang district , Shanghai , China ",
    helpList: [
      {
        text: "Einen TOPS-Händler in Ihrer Nähe finden"
      },
      {
        text: "Abdeckungsoptionen für mein Auto→"
      },
      {
        text: " Händler werden →"
      }
    ]
  },
  warranty: {
    query: "Anfrage",
    warrantyQuery: "Garantie-Anfrage",
    phone: "Handynummer：",
    enterPhone: " Handynummer",//Bitte geben Sie Ihre Handynummer ein
    plateNumber: "Kennzeichen:",//
    enterPlateNumber: "  Kennzeichen oder Fahrgestellnummer",//Bitte geben Sie das Kennzeichen oder die Fahrgestellnummer ein
    digitalCertification: "Garantiekarte",
  },
  offer: {
    title: "Wählen Sie unten Ihr Fahrzeug aus, um verfügbare TOPPF Lackschutzfolie vorgeschnittene Kits anzuzeigen.    ",
    subTitle: "Die angezeigten Preisvorschläge enthalten den Anwendungspreis.",
    brand: "Marke：",
    model: "Modell：",
    filmType: "Folientyp：",
    pleaseSelectBrand: "Bitte Marke auswählen",
    pleaseSelectModel: "Bitte Modell auswählen",
    pleaseSelectFilmType: "Folientyp auswählen",
    selectAddtoCart: "Teil",
    description: "Beschreibung",
    information: "Information",
    price: "Preis",
    entireVehicle: "Gesamtes Fahrzeug",
    frontBumper: "Frontstoßstange",
    hood: "Motorhaube",
    frontFender: "Vorderer Kotflügel",
    door: "Tür",
    roof: "Dach",
    rearFender: "Hinterer Kotflügel",
    tailHood: "Heckklappe",
    rearBumper: "Heckstoßstange",
  }
};



// WEBPACK FOOTER //
// ./src/i18n/langs/de.js